import styled, { css } from 'styled-components';
import type { TExtendedSize } from '../../tokens/types';

const STACKED_SPACING: Record<TExtendedSize, number> = {
    xs: -2,
    sm: -4,
    md: -6,
    lg: -8,
    xl: -16
};

const SPACED_SPACING: Record<TExtendedSize, number> = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 8,
    xl: 8
};

const stackedStyles = css<{ $size: TExtendedSize }>`
    > * {
        position: relative;
        z-index: 1;
        vertical-align: middle;
    }

    /* Negative margin creates overlap effect */
    > :not(:first-child) {
        margin-left: ${({ $size }) => STACKED_SPACING[$size]}px;
    }

    > *:has([data-selected]) {
        z-index: 5;
    }

    /* Only apply focus/hover z-index to interactive elements (buttons or links) */
    > *:has(button:focus-visible),
    > *:has(a:focus-visible) {
        z-index: 10;
    }

    > *:has(button:hover),
    > *:has(a:hover) {
        z-index: 15;
    }
`;

const spacedStyles = css<{ $size: TExtendedSize }>`
    gap: ${({ $size }) => SPACED_SPACING[$size]}px;
`;

export const Container = styled.div<{
    $overlap: boolean;
    $size: TExtendedSize;
}>`
    display: flex;
    align-items: center;

    ${({ $overlap }) => ($overlap ? stackedStyles : spacedStyles)}
`;
